module.exports = __webpack_public_path__ + "img/T918.83c62861.jpg";